var map = {
	"./acceptance.svg": "a721",
	"./built_in.svg": "4faf",
	"./calendar_with_coins.svg": "8372",
	"./convenient.svg": "2e80",
	"./dollar_cup.svg": "eb5c",
	"./e_learnings.svg": "4ea0",
	"./embedded.svg": "0aaa",
	"./hand_with_bag_of_dollars.svg": "6df9",
	"./hand_with_ticket.svg": "84a4",
	"./hight_level.svg": "e89f",
	"./payment_cards.svg": "9798",
	"./ready_to_use.svg": "80aa",
	"./security.svg": "9a8d",
	"./task_list.svg": "5cdd",
	"./transparent.svg": "eb67",
	"./user_friendly.svg": "2ecb",
	"./window_with_glob.svg": "3693"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "82f3";